import { callCareersApi } from "./careers-api";

/**
 * Devuelve el estado del usuario. Si su correo está en la lista de correos
 * autorizados (la cuenta maestra se registra directo en base de datos),
 * se le otorga el rol de administrador automáticamente en su primer acceso.
 */
export const estadoAdministrador = async () =>
  callCareersApi<{ esAdmin: boolean; autorizado: boolean }>("/admin/estado");

/** Lista los correos autorizados junto con si ya activaron su acceso. */
export const listarAccesos = async () => callCareersApi<any[]>("/admin/accesos");

/** Autoriza un correo para el panel; puede hacerse antes de que la persona cree su cuenta. */
export const autorizarCorreo = async (data: { correo: string }) =>
  callCareersApi<{ ok: true; activado: boolean }>("/admin/accesos", {
    method: "POST",
    body: JSON.stringify(data),
  });

/** Retira el acceso administrativo de un correo (la cuenta maestra no puede retirarse). */
export const revocarAcceso = async (data: { correo: string }) =>
  callCareersApi<{ ok: true }>(`/admin/accesos/${encodeURIComponent(data.correo)}`, {
    method: "DELETE",
  });
